"use strict";
//
//
//
//
//
//
'kiwi public';

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;
var _default = {
  data: function data() {
    return {
      recaptchaSiteId: '',
      recaptchaResponse: ''
    };
  },
  computed: {
    isReady: function isReady() {
      return !this.recaptchaSiteId || this.recaptchaResponse;
    }
  },
  created: function created() {
    var _this = this;

    var options = this.$state.settings.startupOptions;
    this.recaptchaSiteId = options.recaptchaSiteId || '';
    this.listen(this.$state, 'network.connecting', function (event) {
      event.network.ircClient.once('socket connected', function () {
        // There should always be a captcha response at this point but just in case
        // there isn't...
        if (_this.recaptchaResponse) {
          event.network.ircClient.raw('CAPTCHA', _this.recaptchaResponse);
        }
      });
    });
  },
  mounted: function mounted() {
    var _this2 = this;

    if (!this.recaptchaSiteId) {
      this.$emit('ready', true);
      return;
    } // Recaptcha calls this callback once it's loaded and ready to be used


    window.recaptchaLoaded = function () {
      window.grecaptcha.render(_this2.$refs.captchacontainer, {
        sitekey: _this2.recaptchaSiteId,
        callback: _this2.recaptchaSuccess,
        'expired-callback': _this2.recaptchaExpired
      });
    };

    var scr = document.createElement('script');
    scr.src = 'https://www.google.com/recaptcha/api.js?onload=recaptchaLoaded&render=explicit';
    scr.defer = true;
    this.$el.appendChild(scr);
  },
  methods: {
    recaptchaSuccess: function recaptchaSuccess(response) {
      this.recaptchaResponse = response;
      this.$emit('ready', true);
    },
    recaptchaExpired: function recaptchaExpired() {
      this.recaptchaResponse = '';
      this.$emit('ready', false);
    }
  }
};
exports.default = _default;
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["Captcha"]
window._kiwi_exports.components.Captcha = exports.default ? exports.default : exports;
